import { ArrowDownTrayIcon, ArrowUpTrayIcon } from '@heroicons/react/20/solid'
import { SyncOutlined } from '@ant-design/icons'
import { Spin, Tabs, Tooltip } from 'antd'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useAxiosTna } from '../../../hooks/useAxiosTna'
import { catGetCodUrl, cfgGetTaxUrl, segConnUrl, tsk17Url, tskRecuperarUrl, usuRcptEmsrUrl } from '../../../api/apiUrl'
import { notifyType } from '../../../types/notifyType'
import { configType } from '../../../types/configType'
import { AppFooter } from '../../../components/AppFooter'
import { NotifyRed } from '../../../components/Msg/NotifyRed'
import { NotifyGreen } from '../../../components/Msg/NotifyGreen'
import { NotifyYellow } from '../../../components/Msg/NotifyYellow'
import { SelRcptEmsr } from '../../../components/Panel/SelRcptEmsr'
import { EditRctGrp } from '../../../components/Panel/cfg/ModData/EditRctGrp'
import { EditRctBan } from '../../../components/Panel/cfg/ModData/EditRctBan'
import { EditRctGto } from '../../../components/Panel/cfg/ModData/EditRctGto'
import { EditRctEnr } from '../../../components/Panel/cfg/ModData/EditRctEnr'
import { EditRctCco } from '../../../components/Panel/cfg/ModData/EditRctCco'
import { EditRctAea } from '../../../components/Panel/cfg/ModData/EditRctAea'
import { msgType } from '../../../types/msgType'
import { setLastAccess } from '../../../utils/lstorageUtil'
import { downloadFile, viewerFile } from '../../../utils/fileUtil'

var jszip = require('jszip')

export const Receptor = ({ page: { code: resource } }) => {
  const { axiosTnaGet, axiosTnaPut } = useAxiosTna()
  const notifyRedRef = useRef()
  const notifyGreenRef = useRef()
  const notifyYellowRef = useRef()
  const [loadPage, setLoadPage] = useState(false)
  const [loadTokenConn, setLoadTokenConn] = useState(true)
  const [loadRcptEmsr, setLoadRcptEmsr] = useState(false)
  const [loadTipoTrib, setLoadTipoTrib] = useState(false)
  const [loadTipoDoc, setLoadTipoDoc] = useState(false)
  const [loadMoneda, setLoadMoneda] = useState(false)
  const [loadBanco, setLoadBanco] = useState(false)
  const [loadData, setLoadData] = useState(false)
  const [loadTask17Add, setLoadTask17Add] = useState(false)
  const [loadTask17Down, setLoadTask17Down] = useState(false)
  const [receptores, setReceptores] = useState([])
  const [tiposTrib, setTiposTrib] = useState([])
  const [tiposDoc, setTiposDoc] = useState([])
  const [monedas, setMonedas] = useState([])
  const [bancos, setBancos] = useState([])
  const [selReceptor, setSelReceptor] = useState(null)
  const [taskInterval, setTaskInterval] = useState(false)
  const [task17, setTask17] = useState({ task: null, id: null, first: true })

  useEffect(() => {
    setLoadPage(loadTokenConn || loadRcptEmsr || loadTipoTrib || loadTipoDoc || loadMoneda || loadBanco)
  }, [loadTokenConn, loadRcptEmsr, loadTipoTrib, loadTipoDoc, loadMoneda, loadBanco])

  useEffect(() => {
    setLoadData(loadTask17Add || loadTask17Down)
  }, [loadTask17Add, loadTask17Down])

  useEffect(() => {
    let isMounted = true

    const tokenConn = async () => {
      const url = segConnUrl()
      await axiosTnaGet(url)
      isMounted && setLoadTokenConn(false)
    }

    tokenConn()

    return () => {
      isMounted = false
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    let isMounted = true

    const rcptEmsr = async () => {
      isMounted && setLoadRcptEmsr(true)

      const url = usuRcptEmsrUrl(resource)
      const [data, err] = await axiosTnaGet(url)

      if (data)
        isMounted && setReceptores(data.rcpt)
      if (err)
        notifyRedRef.current.handleOpen(err, notifyType.error)

      isMounted && setLoadRcptEmsr(false)
    }

    const cfgTipoTrib = async () => {
      isMounted && setLoadTipoTrib(true)

      const url = cfgGetTaxUrl()
      const [data, err] = await axiosTnaGet(url)

      if (data && data.detalle)
        isMounted && setTiposTrib(data.detalle)
      if (err)
        notifyRedRef.current.handleOpen(err, notifyType.error)

      isMounted && setLoadTipoTrib(false)
    }

    const catDocEnr = async () => {
      isMounted && setLoadTipoDoc(true)

      const url = catGetCodUrl(configType.catTipoDoc)
      const [data, err] = await axiosTnaGet(url)

      if (data && data.detalle)
        isMounted && setTiposDoc(data.detalle)
      if (err)
        notifyRedRef.current.handleOpen(err, notifyType.error)

      isMounted && setLoadTipoDoc(false)
    }

    const catMoneda = async () => {
      isMounted && setLoadMoneda(true)

      const url = catGetCodUrl(configType.catMoneda)
      const [data, err] = await axiosTnaGet(url)

      if (data && data.detalle)
        isMounted && setMonedas(data.detalle.filter(dt => dt.bool1))
      if (err)
        notifyRedRef.current.handleOpen(err, notifyType.error)

      isMounted && setLoadMoneda(false)
    }

    const catBanco = async () => {
      isMounted && setLoadBanco(true)

      const url = catGetCodUrl(configType.catBanco)
      const [data, err] = await axiosTnaGet(url)

      if (data && data.detalle)
        isMounted && setBancos(data.detalle)
      if (err)
        notifyRedRef.current.handleOpen(err, notifyType.error)

      isMounted && setLoadBanco(false)
    }

    if (!loadTokenConn) {
      rcptEmsr()
      cfgTipoTrib()
      catDocEnr()
      catMoneda()
      catBanco()
    }

    return () => {
      isMounted = false
    }
    // eslint-disable-next-line
  }, [loadTokenConn])

  useEffect(() => {
    let isMounted = true

    const t17Get = async () => {
      const url = tsk17Url()
      const [data, err] = await axiosTnaGet(url)

      if (data)
        isMounted && setTask17(prev => ({
          ...prev,
          task: data.data,
          id: data.data?.id ?? prev.id,
          first: false
        }))
      if (err)
        console.log(`Task: ${err.message}`)
    }

    if (!loadTokenConn && (task17.first || (!task17.task && task17.id) || (task17.task && !task17.task.complete)))
      t17Get()

    return () => {
      isMounted = false
    }
    // eslint-disable-next-line
  }, [taskInterval, loadTokenConn])

  useEffect(() => {
    let isMounted = true

    const interval = setInterval(() => {
      isMounted && setTaskInterval(prev => !prev)
    }, 5000)

    return () => {
      clearInterval(interval)
      isMounted = false
    }
  }, [])

  const showNotify = (err, type) => {
    if (type === notifyType.error)
      notifyRedRef.current.handleOpen(err, type)
    else if (type === notifyType.success)
      notifyGreenRef.current.handleOpen(err, type)
    else if (type === notifyType.warning)
      notifyYellowRef.current.handleOpen(err, type)
  }

  const clearFile = () => {
    const input = document.getElementById("file-upload-rctcfg")
    if (input)
      input.value = null
  }

  const handleSelReceptor = useCallback((person) => {
    setSelReceptor(person)
  }, [setSelReceptor])

  const handleTask17_Add = async ({ target: { files } }) => {
    let err = null
    let data = null

    if (!files || files.length === 0) {
      clearFile()
      return
    }

    const file = files[0]

    if (file.size > configType.attachMaxSize)
      err = {
        message: msgType.fileKoPeso,
        oops: false
      }
    else if (file.type !== configType.fileTypeTXT)
      err = {
        message: msgType.fileKoTXT,
        oops: false
      }
    else if (!selReceptor)
      err = {
        message: msgType.selectReceptor,
        oops: false
      }

    if (err) {
      notifyYellowRef.current.handleOpen(err, notifyType.warning)
      clearFile()
      return
    }

    setLoadTask17Add(true)

    const formData = new FormData()
    formData.append("", file)

    const url = tsk17Url(selReceptor.ruc)
    const [data_api, err_api] = await axiosTnaPut(url, formData)
    data = data_api
    err = err_api

    if (data) {
      setTask17(prev => ({ ...prev, task: null, id: data.id }))
      notifyGreenRef.current.handleOpen({
        message: msgType.fileRequest,
        oops: false
      }, notifyType.success)
    }
    if (err) {
      notifyRedRef.current.handleOpen(err, notifyType.error)
      clearFile()
    }

    setLoadTask17Add(false)
    setLastAccess()
  }

  const handleTask17_Down = async ({ id, file: record }) => {
    let err = null

    setLoadTask17Down(true)

    const url = tskRecuperarUrl(id)
    const [data, err_api] = await axiosTnaGet(url)
    err = err_api

    if (data) {
      try {
        const { document } = data
        const zip = new jszip()
        const zresult = await zip.loadAsync(document, { base64: true })
        const unzip = await zresult.file(record.fileName).async('base64')
        if (record.contentType === configType.contentTypePDF)
          viewerFile(unzip, record.contentType, record.fileName)
        else
          downloadFile(unzip, record.contentType, record.fileName)
        setTask17(prev => ({ ...prev, task: null, id: null }))
      }
      catch (error) {
        err = {
          message: msgType.apiError,
          detail: error.message,
          oops: true
        }
      }
    }
    if (err)
      notifyRedRef.current.handleOpen(err, notifyType.error)

    setLoadTask17Down(false)
    setLastAccess()
  }

  return (
    <div className="flex flex-col flex-grow md:items-center">
      <NotifyRed ref={notifyRedRef} />
      <NotifyGreen ref={notifyGreenRef} />
      <NotifyYellow ref={notifyYellowRef} />
      {
        loadPage ?
          <div className='my-5 flex justify-center'>
            <Spin tip='Loading....' size='large' />
          </div> :
          <div className='flex-grow'>
            <div className='bg-gray-200 md:flex md:justify-center md:items-center md:space-x-4 pt-3 ant-common-titania'>
              <SelRcptEmsr comboLabel="RECEPTOR" people={receptores} setPerson={handleSelReceptor} flex_basis='basis-96' />
            </div>
            <div className='bg-white flex flex-col p-3 my-3 w-[28rem] min-w-[23rem]'>
              <div className='ant-tabs-titania'>
                <Tabs
                  defaultActiveKey="1"
                  items={[
                    {
                      label: `Grupo`,
                      key: '1',
                      children: <EditRctGrp selReceptor={selReceptor} tiposTrib={tiposTrib} tiposDoc={tiposDoc} monedas={monedas} showNotify={showNotify} />
                    },
                    {
                      label: `Banco`,
                      key: '2',
                      children: <EditRctBan selReceptor={selReceptor} bancos={bancos} monedas={monedas} showNotify={showNotify} />
                    },
                    {
                      label: `Gasto`,
                      key: '3',
                      children: <EditRctGto selReceptor={selReceptor} showNotify={showNotify} />
                    },
                    {
                      label: `Costo`,
                      key: '4',
                      children: <EditRctCco selReceptor={selReceptor} showNotify={showNotify} />
                    },
                    {
                      label: `Área`,
                      key: '5',
                      children: <EditRctAea selReceptor={selReceptor} showNotify={showNotify} />
                    },
                    {
                      label: `Rendición`,
                      key: '6',
                      children: <EditRctEnr selReceptor={selReceptor} tiposTrib={tiposTrib} tiposDoc={tiposDoc} monedas={monedas} showNotify={showNotify} />
                    },
                  ]}
                >
                </Tabs>
              </div>
            </div>
            <div className="bg-white flex flex-row flex-wrap space-x-3 p-2 ant-common-titania">
              <div className="flex items-center text-sm text-indigo-700">
                {
                  (!task17.id || task17.task?.message) ?
                    <>
                      {
                        !loadData ?
                          <label
                            htmlFor="file-upload-rctcfg"
                            className="flex items-center relative cursor-pointer"
                          >
                            <Tooltip title="Cargar archivo de configuración" placement='top'>
                              <ArrowUpTrayIcon className="mr-1.5 h-5 w-5 text-gray-600" aria-hidden="true" />
                            </Tooltip>
                            <span>Cargar</span>
                            <input id="file-upload-rctcfg" name="file-upload-rctcfg" type="file" className="sr-only"
                              onChange={handleTask17_Add}
                              accept=".txt"
                            />
                          </label> :
                          <div className='flex items-center cursor-not-allowed'>
                            <ArrowUpTrayIcon className="mr-1.5 h-5 w-5 text-gray-600" aria-hidden="true" />
                            {
                              loadTask17Add &&
                              <svg aria-hidden="true" role="status" className="inline mr-2 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#00008B" />
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                              </svg>
                            }
                            {`Cargar`}
                          </div>
                      }
                    </> :
                    <>
                      {
                        task17.task?.file ?
                          <div className='flex items-center text-xs'>
                            <Tooltip title="Descargar archivo" placement='top'>
                              <ArrowDownTrayIcon className="mr-1.5 h-5 w-5 text-gray-600" aria-hidden="true" />
                            </Tooltip>
                            {
                              loadTask17Down &&
                              <SyncOutlined spin className='mr-2' />
                            }
                            <button
                              className='text-blue-600'
                              disabled={loadData}
                              onClick={() => handleTask17_Down(task17.task)}
                            >
                              {task17.task.file.fileName}
                            </button>
                          </div> :
                          <div className='flex items-center text-xs'>
                            <ArrowDownTrayIcon className="mr-1.5 h-5 w-5 text-gray-600" aria-hidden="true" />
                            <SyncOutlined spin className='mr-2' />
                            {`Preparando archivo`}
                          </div>
                      }
                    </>
                }
              </div>
              {
                task17.task?.message &&
                <div className='flex items-center'>
                  <p className="text-xs text-red-700">
                    {task17.task?.message}
                  </p>
                </div>
              }
            </div>
          </div>
      }
      <div className='w-full'>
        <AppFooter />
      </div>
    </div>
  )
}
